/**
 * The kitchen board in both schemes - `FRONTEND.md` §9.788, owner O141: *"keď je nastavene biele pozadie bude aj
 * kuchyna biela - ale treba aj písmo prispôsobiť"*.
 *
 * Every other colour on the board is written as a pair - the light one, then the dark one behind `dark:`, the dark
 * one being exactly what the board drew before it followed the scheme. **These are the only words drawn white in
 * both schemes**, because the colour behind them does not change: the ticket's channel strip (`bg-blue-600`,
 * `bg-red-600`, `bg-emerald-600`) and the green and red buttons. Named here so a white word anywhere else on the board
 * reads as what it is - a word that vanishes on the light board - and `kitchen-light-mode.test.ts` can refuse it.
 */
export const ON_SOLID = {
  text: 'text-white',
  soft: 'text-white/80',
  muted: 'text-white/70',
} as const
